const getters = {
  paypalResource: state => {
    return state.paypalResource
  },
  cart: state => {
    return state.cart
  },
  billing: state => {
    return state.billing
  },
  closeupVideoUploadProgess: state => {
    return state.closeupVideoUploadProgess
  },
  closeupWatchTime: state => {
    if (state.closeupWatchTime.length > 0) {
      let totalTime = 0
      state.closeupWatchTime.forEach(ele => {
        totalTime += ele.accessDuration
      })
      console.log('total Time', (totalTime / 3600).toFixed(2))
      return (totalTime / 3600).toFixed(2)
    } else return '0'
  }
}

export default getters
